import { KIND_LABELS } from "@/lib/emailKinds";

const total = (c) => (c?.sent || 0) + (c?.failed || 0) + (c?.skipped || 0) + (c?.retrying || 0);

const pill = (active) =>
  `px-4 py-2 rounded-full text-[10px] font-mono uppercase tracking-[0.2em] border transition-colors ${active ? "bg-[#F59E0B] text-black border-[#F59E0B]" : "border-[#E7DFD5] text-[#44403C] hover:border-[#F59E0B]"}`;

export const EmailKindFilters = ({ counts, kind, onChange }) => {
  const kinds = Object.keys(KIND_LABELS).filter((k) => counts[k]);
  const all = Object.values(counts).reduce((n, c) => n + total(c), 0);
  return (
    <div className="flex flex-wrap gap-2">
      <button onClick={() => onChange("")} data-testid="emails-filter-all" className={pill(!kind)}>All · {all}</button>
      {kinds.map((k) => (
        <button key={k} onClick={() => onChange(k)} data-testid={`emails-filter-${k}`} className={pill(kind === k)}>
          {KIND_LABELS[k]} · {total(counts[k])}
          {counts[k]?.retrying ? <span className="text-[#B45309]"> · {counts[k].retrying} retrying</span> : null}
          {counts[k]?.failed ? <span className="text-red-400"> · {counts[k].failed} failed</span> : null}
        </button>
      ))}
    </div>
  );
};
